/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\Offers\OffersStats\OfferStatsModule.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Wednesday December 27th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Wednesday December 27th 2023 11:25:08 am
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import translator from "MultiLanguage/TranslationWrapper";
import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useIntersectionObserver } from "react-intersection-observer-hook";
import TimeFilter from "Content/TimeFilter/TimeFilter";
import Styles from "Content/SeenCar/SeenCarModule/SeenCarModule.module.css";
import OfferService from "Services/Offer/OfferService";
import OfferTableMemo from "./OfferTable/OfferTable";
import { OfferRowType } from "./OfferRow/OfferRow";
import { OfferUserType } from "Type/offer.type";

type OfferModuleProps = {
    showTimeFilter: boolean
    // myOffer: OfferRowType[],
    myOffer: OfferUserType[],
    viewCount: number,
    userID?: string,
    sellID?: string,
    order?: string,
    orderby?: string,
    setOrderBy?: Function,
    setOrder?: Function,
}

function OfferStatsModule (props: OfferModuleProps) {
    const [page, setPage] = useState(0);
    // const [myOffer, setMyOffer] = useState<OfferRowType[]>(props.myOffer);
    const [myOffer, setMyOffer] = useState<OfferUserType[]>(props.myOffer);
    const [myCount, setMyCount] = useState<number>(props.viewCount);
    const timeFilter = useRef<{curActive: string, curOrder: string} | null>();
    const [ref, { entry }] = useIntersectionObserver();
    const isVisible = entry && entry.isIntersecting;

    useEffect(() => {
        setMyOffer(props.myOffer);
        setMyCount(props.viewCount);
    }, [props.myOffer]);

    useEffect(() => {
        if (isVisible)
            handleLoadMoreViews();
    }, [isVisible]);

    function handleUpdateFilter(filters: {from: string, order: string}) {
        const url = window.location;
        OfferService.getAllOffers({...filters, userid: props.userID, sellid: props.sellID}).then((res: {count: number, offer: OfferUserType[]}) => {
            const searchParams = new URLSearchParams(url.search);
            searchParams.set("page", "1");
            searchParams.set("order", filters.order);
            searchParams.set("orderby", filters.from);
            window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
            setMyOffer(res.offer);
            setMyCount(res.count);
            if (page === 0)
                setPage(-1);
            else
                setPage(0);
        }).catch((error) => {
            console.error(error);
        });
    };

    function handleLoadMoreViews() {
        const url = window.location;
        const myParams = {
            page: 1,
            order: timeFilter?.current?.curOrder,
            from: timeFilter?.current?.curActive,
            userid: props.userID,
            sellid: props.sellID
        };
        const searchParams = new URLSearchParams(url.search);
        if (searchParams.has("page"))
            myParams.page = parseInt(searchParams.get('page')!);
        myParams.page = myParams.page + 1;
        // OfferService.getAllOffers(myParams).then((res: {count: number, offer: OfferRowType[]}) => {
        OfferService.getAllOffers(myParams).then((res: OfferUserType[]) => {
            const searchParams = new URLSearchParams(url.search);
            searchParams.set("page", myParams.page.toString());
            window.history.replaceState(null, "", `${url.pathname}?${searchParams.toString()}`);
            setPage(myParams.page);
            setMyCount(res.length);
            setMyOffer([...myOffer, ...res]);
        }).catch((error: any) => {
            console.error(error);
        });
    };

    return (
        <>
            <div className={`${Styles.holderTopBar}`} >
                <p className="m-0">{translator.decode("dynamic.total")}: {myCount}</p>
                {
                    props.showTimeFilter ?
                    <TimeFilter ref={timeFilter} handleUpdateFilter={handleUpdateFilter} order={props.order} orderBy={props.orderby} setOrderBy={props.setOrderBy} setOrder={props.setOrder} />
                    :null
                }
            </div>
            <OfferTableMemo displayName={false} offer={myOffer} order={props.order ?? timeFilter?.current?.curOrder} />
            {
                myCount > 0 && myOffer.length > 0 && myOffer.length !== myCount ?
                <Button ref={ref} className="p-2" onClick={handleLoadMoreViews}>{translator.decode("dynamic.more")}</Button>
                :null
            }
        </>
    )
}

export default OfferStatsModule;
